import {ApiResponseDto, DtoDeviceInfo, DtoLoginResponse, FormValueListEntryDto} from "../../core/interfaces/core.types";
import {SignatureDto} from "../../cross/user-signatures/type/user-signatures.types";
import {FormFieldsDtoForInsurance} from "../../ob/types/ob.interfaces";


export interface RegistrationRequestOtpDto {

  phoneNumber?: string;
  deviceInfo?: DtoDeviceInfo;

  otpCode?: string;
  registrationGuid?: string;
  refresh?: boolean;
  eMail?: string;
  password?: string;

  pictureBase64?: string | null;
  pictureMimeType?: string | null;

  referralGuid?: string;

}

export interface RegistrationFinishResult {

  customerCreationSuccessful: boolean;
  errorDto: ApiResponseDto;
  logonToken: DtoLoginResponse;

}


export enum PersonGender {
  notDefined,
  male,
  female,
  nonBinary
}

export enum PersonMaritalStatus {
  notDefined,
  married,
  partnership,
  single,
  widowed,
  divorced,
  separated
}

export interface RegistrationDto {
  id?: number;
  phoneNumber?: string;
  registrationGuid?: string;

  deviceInfo?: DtoDeviceInfo;

  email?: string;
  firstName?: string;
  lastName?: string;
  gender?: PersonGender;
  addressCasually?: boolean; //true means du, false means sie
  nickName?: string;
  addressStreet?: string;

  addressStreetNumber?: string;
  addressLine2?: string;
  addressCity?: string;
  addressPostalCode?: string;
  dateOfBirth?: Date;
  maritalStatus?: PersonMaritalStatus;

  childrenCount?: number;

  signatures?: SignatureDto[];

}

export enum ForgotPasswordOptionEnum {
  phone,
  email,
  contactUsPhone,
  contactUsWhatsApp
}


export interface ForgotPasswordRequestDto {

  anyUserText?: string;
  selectedOption?: ForgotPasswordOptionEnum;
  deviceInfo: DtoDeviceInfo;
  otpCode?: string;
  newPassword?: string;

}

export interface ForgotPasswordOtpOptionDto {
  type: ForgotPasswordOptionEnum;
  label: string;
  value: string;
  message: string;
}

export interface ForgotPasswordDto {

  label: string;
  description: string;
  imageUrl: string;

  options: ForgotPasswordOtpOptionDto[];

}

export interface FormFieldDtoForRegistration {

  access: FieldAccess;
  hasValueList: boolean;
  id: string;
  order: number;
  uiDescription: string;
  uiInputControl: string;
  uiLabel: string;
  valueList: FormValueListEntryDto[]
  value?: any;
}

export interface FormRegistrationFieldsDto {
  [key: string]: FormFieldDtoForRegistration;
}


export enum FieldAccess {
  READ,
  UPDATE,
  HIDDEN
}
